angular.module('contabilidad.asociarfacturas')
  .config(Config)

Config.$inject = ['$stateProvider']

function Config ($stateProvider) {
  $stateProvider.state('contabilidad.asociarfacturas', {
    url: '/asociarfacturas?{idempresa}&{cuenta}&{idempresa_receptor}&{cuenta_receptor}&{fechaInicial:date}&{fechaFinal:date}&{naturaleza}',
    // params    : {comisionistas: {array: true}, proveedores: {array: true}, clientes: {array: true}},
    data: {title: 'Asociar Facturas'},
    template: '<contabilidad-asociarfacturas busqueda="$params"></contabilidad-asociarfacturas>',
    controller: Controller,
  })
}

Controller.$inject = ['$scope', '$stateParams']

function Controller ($scope, $stateParams) {
  $scope.$params = $stateParams
}




// WEBPACK FOOTER //
// ./src/contabilidad/asociarfacturas/routes/contabilidad-asociarfacturas.js